import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/plus.svg';

export const IconPlus = createIconComponent(Icon);
